const ENV = process.env || {};

const AUTH_URL = ENV.REACT_APP_AUTH_URL;
const API_URL = ENV.REACT_APP_API_URL;
const ONTRUCK_AUTH_CLIENTID = ENV.REACT_APP_ONTRUCK_AUTH_CLIENTID;
const GOOGLE_APPS_CLIENTID = ENV.REACT_APP_GOOGLE_APPS_CLIENTID;

export { AUTH_URL, API_URL, ONTRUCK_AUTH_CLIENTID, GOOGLE_APPS_CLIENTID };
